import React from 'react';
import _ from 'lodash';
import { formatMoney } from 'accounting';

const ProductTile = ({ product }) => {

  if (product) {
    const firstImageKey = _.get(Object.keys(product.path_images), ['0'], '');
    return (

      <div className='product'>
        <div className='product-tile'>
          <div className='product-img'>
            <img
              alt={product.name}
              src={`${process.env.REACT_APP_API_URL}/${product.path_images[firstImageKey]}`}
            />
          </div>
          <div className='product-info'>
            <p className='product-name truncate'> {product.name} </p>
            <p className='product-description truncate'>
              {' '}
              {product.description}{' '}
            </p>
            <p className='product-price truncate'>
              {' '}
              {formatMoney(product.price)}{' '}
            </p>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default ProductTile;
